// Libarary Class
import { HttpClient } from '@angular/common/http';
import { AfterViewInit, Component, HostListener, Inject, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { NgbCalendar, NgbDatepickerConfig, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import * as $ from 'jquery';
import { ToastrService } from 'ngx-toastr';
import { forkJoin, Subscription } from 'rxjs';
const _ = require('lodash');

// Service Class
import { BroadcastService } from './../../../../services/infrastructure/broadcaster.service';
import { ConfigService } from './../../../../services/infrastructure/config.service';
import { LoaderService } from './../../../../services/infrastructure/loader.service';
import { LocalStorageService } from './../../../../services/infrastructure/local-storage.service';
import { PlotSeedService } from './../../../../services/seed/plot-seed.service';


// Class
import { LolLoggerService } from '../../../../common/shared/lol-logger.service';
import { MasterConstants } from './../../../../common/constants/master-constants';
import { DashboardFilter } from './../../../../models/DashboardFilter';
import { CommonService } from '../../../../services/common/common.service';
import { ViewChild, ChangeDetectorRef } from '@angular/core';
import { NgSelectComponent } from '@ng-select/ng-select';

@Component({
  selector: 'app-plot-seed-create-order',
  templateUrl: './plot-seed-create-order.component.html',
  styleUrl: './plot-seed-create-order.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class PlotSeedCreateOrderComponent implements OnInit, OnChanges, AfterViewInit, OnDestroy {
  @ViewChild('maturityToSearch') maturityToSelect: NgSelectComponent;
  @ViewChild('maturityFromSearch') maturityFromSelect: NgSelectComponent;
  private subscription = new Array<Subscription>();
  plotSeedLeadDate = 0;
  dashboardFilter: DashboardFilter;
  deliverToData: any;
  headerCompany = MasterConstants.US_COMPANYCODE;
  headerYear: any;
  plotSeedOrder: PlotSeedOrder;
  salesManagerAccounts: any;
  shipToData: any;
  isProductExist = false;
  productLineData: any;
  productLineDateSetupList: any;
  displayedColumns: string[] = ['marketingBrand', 'variety', 'maturity', 'orderQty', 'uom'];
  selectedDealer: any;
  selectedSalesManager: any;
  deliverTo: any;
  isNotValid: any;
  isPlaceOrderDisable = true;
  productSearchFilter: any;
  productFilters: any;
  marketingMasterList: any = [];
  filterValueList: any = [];
  shipToDataLoading = true;
  locationDataLoading = true;
  plotSeedOrderSource: MatTableDataSource<any>;
  errorsList: Array<string> = [];
  error = false;
  plotSeedOrderSourceCopy: any;
  errorMsgs = new Array();
  showErrorBlock = false;
  currentErrorRow = 1;
  index = 0;
  nextErrorId = 0;
  isEditMode = false;
  IsLinesGreaterThanZeroDisable = true;
  datemodel: NgbDateStruct;
  dateFilter: any;
  hasChangeAdded = false;
  userMenuAccessList: any;
  maxDate: Date = new Date();
  minDate: Date = new Date();
  defaultRequestDate: Date = new Date();
  readOnlyAccess = false;
  editFullAccess = false;
  isUserSalesManager = false;
  soldOutItemMsg: string = '';
  availableMaturityOptions: any[] = [];
  // Search Type set Up for grid
  searchTypeList: any[] = [
    { name: 'Hybrid Variety', value: 'Variety' },
    { name: 'Maturity', value: 'Maturity' }
  ];
  allocatedQuantity: number = 0;
  avilableQuantity: number = 0;
  totalOrderQuantity: number = 0;
  enableSearchButton = false;
  originalItemList: any;
  disableDeliverTo = false;
  isOrderEditable: boolean = false;
  orderHeaderId: number = 0;
  fromNewOrder: boolean = true;
  constructor(public http: HttpClient,
    @Inject('BASE_URL') public baseUrl: string,
    private router: Router,
    private broadcastService: BroadcastService,
    private configService: ConfigService,
    private plotSeedService: PlotSeedService,
    private localStorageService: LocalStorageService,
    private loaderService: LoaderService,
    private toastrService: ToastrService,
    private commonService: CommonService,
    private cdRef: ChangeDetectorRef) {
    this.dashboardFilter = new DashboardFilter();
    this.plotSeedOrder = new PlotSeedOrder();
    this.subscription.push(this.broadcastService.on<any>(this.configService.DATA_CHANGE_ADDED).subscribe((data) => {
      if (data.hasChangeAdded != undefined) {
        this.hasChangeAdded = data.hasChangeAdded;
      }
    }));
  }

  ngOnInit() {
    this.setAndValidateDefaultData();   
    this.bindDataSource([], true);
    this.resetProductFilter();
    //this.getOrderDetails();
  }

  setAndValidateDefaultData() {
    this.subscription.push(this.plotSeedService.plotSeedOrderId.subscribe(headerId => {
      if (headerId && headerId != 0) {
        this.orderHeaderId = headerId;
        this.fromNewOrder = false;
      }
      else {
        this.orderHeaderId = 0;
      }

      if (this.localStorageService.get(MasterConstants.EVOLVE_ACCESS)) {
        const data = JSON.parse(this.localStorageService.get(MasterConstants.EVOLVE_ACCESS));
        if (data !== null && data !== undefined && data.resultData.length > 0) {
          this.userMenuAccessList = data.resultData.find(x => x.userIdCompanyCode == MasterConstants.US_COMPANYCODE).userMenuAccessList;
          if (this.commonService.checkUserRoleAccessTypeForMenu(this.userMenuAccessList, MasterConstants.FUNCTION_CODE.PLOT_SEED)) {
            this.readOnlyAccess = this.commonService.checkUserRoleAccessType(MasterConstants.FUNCTION_CODE.PLOT_SEED, MasterConstants.USER_ACCESS.READ_ONLY, this.userMenuAccessList);
            this.editFullAccess = this.commonService.checkUserRoleAccessType(MasterConstants.FUNCTION_CODE.PLOT_SEED, MasterConstants.USER_ACCESS.EDIT_FULL, this.userMenuAccessList);
            this.subscription.push(
              this.plotSeedService.checkCreateAccessForPlotSeed().subscribe((response) => {
                this.editFullAccess = response && this.editFullAccess ? true : false;
                if (!this.editFullAccess && (!this.orderHeaderId || this.orderHeaderId == 0)) {
                  this.router.navigate(['/cc/landing-data']);
                }
                this.getPlotSeedOrderInitialData();
              })
            );

          } else {
            this.router.navigate(['/cc/landing-data']);
          }
          const isActiveUser = data.resultData.find(x => x.userIdCompanyCode == this.headerCompany);
          if (isActiveUser.plotSeedLeadDay) {
            this.plotSeedLeadDate = isActiveUser.plotSeedLeadDay;

            this.setDefaultRequestDate();
          }
        }
      }
      // Set the default value
      if (this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR)) {
        this.headerYear = JSON.parse(this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR));
      }
      this.errorMsgs = new Array();
    }));
  }

  setDefaultRequestDate() {
    var currentDate = this.addBusinessDays(new Date(), this.plotSeedLeadDate);
    const strCurrentDate = (new Date(currentDate)).toLocaleDateString('en-US').replace(/\u200E/g, '');

    const defaultRequestDate = new Date(strCurrentDate);
    this.defaultRequestDate = defaultRequestDate;
    const startDate = new Date(this.localStorageService.get(MasterConstants.CROP_YEAR_START_DATE));
    const endDate = new Date(this.localStorageService.get(MasterConstants.CROP_YEAR_END_DATE));

    this.maxDate = endDate;
    this.minDate = new Date();
    this.minDate = this.minDate >= startDate ? this.minDate : startDate;
    const defaultDateOnly = new Date(defaultRequestDate.getFullYear(), defaultRequestDate.getMonth(), defaultRequestDate.getDate());
    const startDateOnly = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate());
    const endDateOnly = new Date(endDate.getFullYear(), endDate.getMonth(), endDate.getDate());
    // Check if defaultRequestDate falls between start and end
    if (defaultDateOnly >= startDateOnly && defaultDateOnly <= endDateOnly) {
      this.plotSeedOrder.RequestedDate = new Date(strCurrentDate);
    }
  }

  addBusinessDays(startDate: Date, leadDays: number): Date {
    let result = new Date(startDate);

    // Special case: if leadDays = 0 and today is weekend → push to next Monday
    if (leadDays === 0 && (result.getDay() === 0 || result.getDay() === 6)) {
      do {
        result.setDate(result.getDate() + 1);
      } while (result.getDay() === 0 || result.getDay() === 6);
      return result;
    }

    // Normal case: add business days
    for (let i = 0; i < leadDays;) {
      result.setDate(result.getDate() + 1);
      if (result.getDay() !== 0 && result.getDay() !== 6) {
        i++;
      }
    }

    return result;
  }

  // Get Plot Seed Initial Data
  getPlotSeedOrderInitialData() {
    this.loaderService.setLoaderStatus(true);
    this.subscription.push(this.plotSeedService.getPlotSeedCreateOrderHeaderData().subscribe((result: any) => {
      if (result) {
        this.isUserSalesManager = result.isUserSalesManager;
        this.salesManagerAccounts = result.salesManagerList;
        this.clearDetailGrid();
        if (this.isUserSalesManager) {
          this.shipToData = result.shipToAscAccountList;
          this.plotSeedOrder.SalesManagerAccount = this.salesManagerAccounts[0].accountNumber;
        }
        this.shipToDataLoading = false;
        this.locationDataLoading = false;
        this.productLineData = result.productLineList;
        this.productLineDateSetupList = result.productLineDateSetupList;
      } else {
        this.shipToDataLoading = false;
        this.locationDataLoading = false;
      }
      this.loaderService.setLoaderStatus(false);
      if (this.orderHeaderId > 0) {
        this.loadOrderDetails();
      }
    }, error => {
      this.loaderService.setLoaderStatus(false);
      this.shipToDataLoading = false;
      this.locationDataLoading = false;
    }));
  }

  loadOrderDetails() {
    this.loaderService.setLoaderStatus(true);
    this.enableSearchButton = true;
    this.subscription.push(this.plotSeedService.getPlotSeedOrderSummaryData(this.orderHeaderId).subscribe((result: any) => {
      if (result) {
        this.displayedColumns = ['marketingBrand', 'variety', 'maturity', 'orderQty', 'uom', 'status'];

        this.plotSeedOrder.OrderNumber = result.webOrderNumber;

        if (!this.fromNewOrder) {
          // Sales Manager
          const salesManagerDetails = {
            accountNumber: result.salesManagerAccounNumber,
            accountName: result.salesManagerAccountName,
            accountNameCityState: result.salesManagerAccounNumber +' - '+ result.salesManagerAccountName
          };

          this.salesManagerAccounts = [salesManagerDetails];

          this.plotSeedOrder.SalesManagerAccount = result.salesManagerAccounNumber;

          // Ship To Account
          const accountDetails = {
            accountNumber: result.shipToAccount,
            address1: result.shipToAddress1,
            city: result.shipToCity,
            state: result.shipToState,
            zipCode: result.zipCode,
            accountNameCityState: result.accountName
          };

          this.shipToData = [accountDetails];
          this.selectedDealer = accountDetails;
          this.plotSeedOrder.ShipToAccount = result.shipToAccount;

          // Product Line
          const productLineDetails = {
            id: result.productLineId,
            value: result.productLine
          };

          this.productLineData = [productLineDetails];
          this.plotSeedOrder.ProductLine = result.productLineId;
        }
        
        if (result.deliverToAccount) {
          // Create the object
          const deliverToDetails = {
            accountNumber: result.deliverToAccount,
            address1: result.deliverToAddress1,
            city: result.deliverToCity,
            state: result.deliverToState,
            zipCode: result.deliverToZipCode
          };
          this.deliverTo = deliverToDetails;
        }

        this.deliverToData = result.deliverTo;

        this.plotSeedOrder.DeliverToAccount = result.deliverToAccount;
        this.plotSeedOrder.DeliverToAnotherLocation = result.deliverToAccount > 0 ? true : false;
        this.plotSeedOrder.RequestedDate = result.requestDeliverDate;
        this.plotSeedOrder.DeliveryInstructionsCodes = result.deliverInstructions;
        this.plotSeedOrder.IsCustomerPickup = result.customerPickup;
        
        this.plotSeedOrder.CustomerPO = result.customerPO;
        let rowId: Number = 0;
        if (!this.editFullAccess) {
          result.isEditable = this.editFullAccess;
        }
        this.isOrderEditable = result.isEditable;
        if (result.isEditable) {
          this.minDate = this.defaultRequestDate;
          this.originalItemList = [
            ...result.detailsData,
            ...result.additionalOrderDetail.items
          ];
          this.readOnlyAccess = false;
          this.IsLinesGreaterThanZeroDisable = false;
          this.allocatedQuantity = result.additionalOrderDetail?.allocatedQuantity;
          this.avilableQuantity = result.additionalOrderDetail?.availableQuantity;
          this.totalOrderQuantity = result.additionalOrderDetail?.totalOrderQuantity;

        } else {
          this.originalItemList = [...result.detailsData];
          this.readOnlyAccess = true;
          this.IsLinesGreaterThanZeroDisable = true;
        }

        let marketingIds = [];
        const seen = new Set();
        let hasQty = false;
        this.originalItemList.forEach(product => {
          if (!seen.has(product.marketingBrand)) {
            seen.add(product.marketingBrand);
            marketingIds.push({ id: product.marketingBrand, value: product.marketingBrand ? product.marketingBrand : 'Blank' });
          }
          rowId = +rowId + 1;
          product.rowId = +rowId;
          product.orderQuantity = product.orderQuantity;
          //if (product.orderQuantity > 0) {
          //  hasQty = true;
          //}
          product.status = product.status;
          product.lineErrors = { 'rowId': product.rowId, 'errors': [] };
        });
        this.plotSeedOrder.IsLinesGreaterThanZero = hasQty;
        marketingIds = marketingIds.sort((a, b) => a.value.localeCompare(b.value));
        this.marketingMasterList = marketingIds;
        this.availableMaturityOptions = result.availableMaturityOptions || [];
        this.bindDataSource(this.originalItemList, true, true);

      }
      this.loaderService.setLoaderStatus(false);
    }, (error) => {
      this.loaderService.setLoaderStatus(false);
    }));
  }

  isDisabled(isSalesManager: boolean): boolean {
    if (isSalesManager && this.isUserSalesManager) {
      return true;
    }

    if (this.fromNewOrder) {
      return false;
    }

    return this.readOnlyAccess || this.isOrderEditable;
  }

  ngAfterViewInit() {
    // Set Dynamic Height of Panels
    this.setSeedEditPageHeight();
  }

  @HostListener('window:resize', ['$event']) onresize(event) {
    this.setSeedEditPageHeight();
  }

  // Set Dynamic Height of the Modified product listing table
  setSeedEditPageHeight() {
    const seedEditHeight = window.innerHeight - $('.navbar').outerHeight() - $('.SeedFulfillBtnSec').outerHeight();
    $('.seedEfulfillmentOuter').css('height', seedEditHeight + 'px');
  }

  // Observe Input element change
  ngOnChanges(changes: SimpleChanges) {
    this.productSearchFilter = this.searchTypeList[0].value;
  }

  resetEditFields(isShipTo = false) {
    if (this.orderHeaderId > 0) {
      this.orderHeaderId = 0;
      this.isOrderEditable = false;
      if (this.plotSeedOrder.DeliverToAccount) {
        this.plotSeedOrder.DeliverToAccount = null;
        this.deliverTo = null;
        this.plotSeedOrder.DeliverToAnotherLocation = false;
      }
     
      this.setDefaultRequestDate();
      this.plotSeedOrder.CustomerPO = null;
      this.plotSeedOrder.DeliveryInstructionsCodes = null;
      this.plotSeedOrder.IsCustomerPickup = false;
      this.plotSeedOrder.IsLinesGreaterThanZero = false;
      this.readOnlyAccess = false;
      if (isShipTo) {
        this.originalItemList = null;
        this.enableSearchButton = false;
        this.availableMaturityOptions = null;
        this.clearDetailGrid();
      }
      this.enableDisablePlaceOrder();
    }
  }

  clearDetailGrid() {
    this.allocatedQuantity = 0;
    this.avilableQuantity = 0;
    this.totalOrderQuantity = 0;
    this.IsLinesGreaterThanZeroDisable = true;
    this.plotSeedOrder.IsLinesGreaterThanZero = false;
    this.productSearchFilter = this.searchTypeList[0].value;
    this.marketingMasterList = [];
    this.bindDataSource([], true);
    this.clearAllFilter();
    this.revertAllChanges();
  }
  // Get product list based on account selected
  getProductsList() {
    if (this.plotSeedOrder.ShipToAccount && this.plotSeedOrder.ProductLine) {
      this.loaderService.setLoaderStatus(true);
      this.clearDetailGrid();

      let rowId: Number = 0;

      const filter = {
        SalesManagerAccountNumber: this.plotSeedOrder.SalesManagerAccount,
        ProductLineId: this.plotSeedOrder.ProductLine
      };
      this.subscription.push(this.plotSeedService.getPlotSeedDetailsData(filter).subscribe(result => {
        const data = result;
        this.allocatedQuantity = data?.allocatedQuantity;
        this.avilableQuantity = data?.availableQuantity;
        this.totalOrderQuantity = data?.totalOrderQuantity;
        if (result.status && data && data.items && data.items.length > 0) {
          this.enableSearchButton = true;
          this.originalItemList = data.items;
          let marketingIds = [];
          const seen = new Set();

          this.originalItemList.forEach(product => {
            if (!seen.has(product.marketingBrand)) {
              seen.add(product.marketingBrand);
              marketingIds.push({ id: product.marketingBrand, value: product.marketingBrand ? product.marketingBrand : 'Blank' });
            }
            rowId = +rowId + 1;
            product.rowId = +rowId;
            product.orderQuantity = 0;
            product.preferredPackagingSize = null;
            product.lineErrors = { 'rowId': product.rowId, 'errors': [] };
            product['lastUpdatedTime'] = new Date();
          });
          marketingIds = marketingIds.sort((a, b) => a.value.localeCompare(b.value));
          this.marketingMasterList = marketingIds;
          this.availableMaturityOptions = data.availableMaturityOptions || [];
          this.bindDataSource(this.originalItemList, true);
        } else {
          this.allocatedQuantity = 0;
          this.avilableQuantity = 0;
          this.totalOrderQuantity = 0;
          this.isPlaceOrderDisable = true;
          this.bindDataSource([], true);
          this.toastrService.error("Allocation does not exist for the selected Sales Manager and Product Line");
        }

        this.loaderService.setLoaderStatus(false);
      }, (error => {
        LolLoggerService.error(error);
        this.loaderService.setLoaderStatus(false);
      })));

    } else {
      this.bindDataSource([], true);
      this.loaderService.setLoaderStatus(false);
    }
  }
  onMaturityFromChange() {
    const fromVal = this.productFilters.MaturityFrom;
    const toVal = this.productFilters.MaturityTo;
    const fromSelected = fromVal !== null && fromVal !== undefined;
    const toSelected = toVal !== null && toVal !== undefined;

    // If both selected and both are numeric (not the literal 'Blank') -> validate range
    if (fromSelected && toSelected && fromVal !== 'Blank' && toVal !== 'Blank') {
      if (this.compareMaturityValues(fromVal, toVal) > 0) {
        this.toastrService.error('Maturity To should be greater than or equal to Maturity From');

        // Deselect the invalid To value in the model and UI (do not revert From)
        this.productFilters.MaturityTo = null;
        this.clearNgSelectModel(this.maturityToSelect);

        // Update filter display and grid
        this.keepFilter();
        this.applyAllFilters();
        return;
      }
    }
    else if (toSelected && toVal === 'Blank') {
      // If MaturityTo is the literal 'Blank' and MaturityFrom is a numeric value -> error (per requirement)
      if (fromSelected && fromVal !== 'Blank') {
        this.toastrService.error('Maturity From cannot be greater than Maturity To');

        // Clear the invalid selection on To and update
        this.productFilters.MaturityTo = null;
        this.clearNgSelectModel(this.maturityToSelect);
        this.keepFilter();
        this.applyAllFilters();
        return;
      }
      // If From is not selected, selecting To = 'Blank' is allowed (shows blank-only)
    }

    // If user selected 'Blank' as From and To is numeric -> allowed. No immediate validation needed.
  }
  // Validate when Maturity To changes
  onMaturityToChange() {
    const fromVal = this.productFilters.MaturityFrom;
    const toVal = this.productFilters.MaturityTo;
    const fromSelected = fromVal !== null && fromVal !== undefined;
    const toSelected = toVal !== null && toVal !== undefined;

    // If both selected and both numeric (not 'Blank') -> validate numeric range
    if (fromSelected && toSelected && fromVal !== 'Blank' && toVal !== 'Blank') {
      if (this.compareMaturityValues(fromVal, toVal) > 0) {
        this.toastrService.error('Maturity To should be greater than or equal to Maturity From');

        // Deselect the invalid To selection
        this.productFilters.MaturityTo = null;
        this.clearNgSelectModel(this.maturityToSelect);

        this.keepFilter();
        this.applyAllFilters();
        return;
      }
    } else if (toSelected && toVal === 'Blank') {
      // If MaturityTo is the literal 'Blank' and MaturityFrom is a numeric value -> error (per requirement)
      if (fromSelected && fromVal !== 'Blank') {
        this.toastrService.error('Maturity From cannot be greater than Maturity To');

        // Clear the invalid selection on To and update
        this.productFilters.MaturityTo = null;
        this.clearNgSelectModel(this.maturityToSelect);
        this.keepFilter();
        this.applyAllFilters();
        return;
      }
      // If From is not selected, selecting To = 'Blank' is allowed (shows blank-only)
    } else if (!fromSelected && toSelected) {
      // If only To is selected and it's not the literal 'Blank', show warning and deselect To
      if (toVal !== 'Blank') {
        this.toastrService.warning('Maturity From and Maturity To both should be selected');

        this.productFilters.MaturityTo = null;
        this.clearNgSelectModel(this.maturityToSelect);

        this.keepFilter();
        return;
      }
    }
  }
  private clearNgSelectModel(select: NgSelectComponent) {
    if (!select) { return; }
    const anySelect = select as any;
    try {
      if (typeof anySelect.clearModel === 'function') {
        anySelect.clearModel();
      }
      if (typeof anySelect.clear === 'function') {
        anySelect.clear();
      }
      // fallback: clear selectedItems / selectedValue if present
      if ('selectedItems' in anySelect) {
        anySelect.selectedItems = [];
      }
      if ('selectedValue' in anySelect) {
        anySelect.selectedValue = null;
      }
    } catch (e) {
      // noop - best-effort clear
    }
    // ensure Angular picks up the change
    this.cdRef.detectChanges();
  }

  // Compare maturity values (e.g., "0.9-1.4" vs "2.0-2.4")
  compareMaturityValues(from: string, to: string): number {
    const fromValue = this.extractMaturityNumericValue(from);
    const toValue = this.extractMaturityNumericValue(to);
    return fromValue - toValue;
  }

  // Extract numeric value from maturity string (e.g., "0.9-1.4" -> 0.9)
  extractMaturityNumericValue(maturityString: string): number {
    if (maturityString === null || maturityString === undefined) return NaN;
    const s = String(maturityString).trim();
    if (s === '') return NaN;

    const parts = s.split('-');
    if (!parts || parts.length === 0) return NaN;

    const parsed = parseFloat(parts[0]);
    return isNaN(parsed) ? NaN : parsed;
  }


  // Combined filter application (for Search button)
  applyAllFilters(isCheckBox = false) {
    let filteredItems = [...this.originalItemList];

    // Variety / Brand filter
    if (this.productFilters.Variety && this.productFilters.Variety.trim()) {
      const searchTerm = this.productFilters.Variety.replace(/\s+/g, ' ').trim().toLowerCase();

      filteredItems = filteredItems.filter(item => {
        const brand = String(item.brand || item.Brand || '').toLowerCase();
        return brand.includes(searchTerm);
      });
    }

    // Maturity filter - support literal 'Blank' selection with special From semantics
    const fromVal = this.productFilters.MaturityFrom;
    const toVal = this.productFilters.MaturityTo;
    const fromSelected = fromVal !== null && fromVal !== undefined;
    const toSelected = toVal !== null && toVal !== undefined;

    if (fromSelected || toSelected) {
      // Case: From = 'Blank' and To is numeric -> include items with empty maturity OR maturities <= To
      if (fromVal === 'Blank' && toSelected && toVal !== 'Blank') {
        const toValue = this.extractMaturityNumericValue(toVal);
        filteredItems = filteredItems.filter(item => {
          if (!item.maturity || item.maturity.trim() === '') return true; // include blanks
          const itemVal = this.extractMaturityNumericValue(item.maturity);
          return !isNaN(itemVal) && !isNaN(toValue) && itemVal <= toValue;
        });
      }
      // Case: either side explicitly 'Blank' (and above handled), but both blank -> show blanks only
      else if (fromVal === 'Blank' || toVal === 'Blank') {
        filteredItems = filteredItems.filter(item => !item.maturity || item.maturity.trim() === '');
      }
      // Case: both numeric -> normal numeric range
      else if (fromSelected && toSelected) {
        const fromValue = this.extractMaturityNumericValue(fromVal);
        const toValue = this.extractMaturityNumericValue(toVal);

        filteredItems = filteredItems.filter(item => {
          const itemMaturityValue = this.extractMaturityNumericValue(item.maturity);
          return (
            !isNaN(itemMaturityValue) &&
            !isNaN(fromValue) &&
            !isNaN(toValue) &&
            itemMaturityValue >= fromValue &&
            itemMaturityValue <= toValue
          );
        });
      }
    }

    if (!isCheckBox && filteredItems.length === 0) {
      this.toastrService.info('No items match the selected filters');
    }

    this.bindDataSource(filteredItems, false);
  }
  // Search button click handler
  onSearchClick() {
    // Validate maturity filters
    this.keepFilter();

    const fromVal = this.productFilters.MaturityFrom;
    const toVal = this.productFilters.MaturityTo;
    const fromSelected = fromVal !== null && fromVal !== undefined;
    const toSelected = toVal !== null && toVal !== undefined;

    // If MaturityTo is literal 'Blank' while MaturityFrom is numeric -> error per requirement
    if (toSelected && toVal === 'Blank' && fromSelected && fromVal !== 'Blank') {
      this.toastrService.error('Maturity From cannot be greater than Maturity To');
      // Clear invalid To selection
      this.productFilters.MaturityTo = null;
      this.clearNgSelectModel(this.maturityToSelect);
      return;
    }

    // If exactly one side is selected and the selected value is NOT the literal 'Blank', warn
    if ((fromSelected && !toSelected) || (!fromSelected && toSelected)) {
      const selectedVal = fromSelected ? fromVal : toVal;
        this.toastrService.warning('Maturity From and Maturity To both should be selected');
        return;
      // if selectedVal === 'Blank' -> allow, user is filtering for blank maturities (handled in applyAllFilters)
    }

    // If both sides selected and both are not 'Blank' strings, validate numeric range
    if (fromSelected && toSelected && fromVal !== 'Blank' && toVal !== 'Blank') {
      if (this.compareMaturityValues(fromVal, toVal) > 0) {
        this.toastrService.error('Maturity To should be greater than or equal to Maturity From');
        this.productFilters.MaturityTo = '';
        return;
      }
    }

    // Apply all filters
    this.applyAllFilters();
  }

  getOrderList() {
    const orderItems = this.originalItemList.filter(x => (x.orderDetailID > 0 && x.active == true) || (x.orderDetailID == 0 && x.orderQuantity > 0)).map(product => ({
      orderDetailId: product.orderDetailID,
      orderQuantity: product.orderQuantity,
      brand: product.brand,
      uom: product.uom,
      marketingBrand: product.marketingBrand,
      maturity: product.maturity,
      lastUpdatedTime: product.lastUpdatedTime
    }));
    const {
      SalesManagerAccount,
      ProductLine,
      RequestedDate,
      ShipToAccount,
      DeliverToAnotherLocation,
      DeliverToAccount,
      DeliveryInstructionsCodes,
      CustomerPO,
      IsCustomerPickup
    } = this.plotSeedOrder;

    const header = {
      orderHeaderId: this.orderHeaderId,
      salesManagerAccount: SalesManagerAccount,
      productLine: ProductLine,
      requestedDate: new Date(RequestedDate).toDateString(),
      shipToAccount: ShipToAccount,
      deliveredToAccount: DeliverToAnotherLocation && DeliverToAccount ? DeliverToAccount : null,
      deliveryInstruction: DeliveryInstructionsCodes?.trim(),
      custPonumber: CustomerPO?.trim() || null,
      customerPickup: !!IsCustomerPickup,
      fromEditConfirmationPage: this.isOrderEditable,
      orderDetailsData: orderItems
    };

    return header;
  }

  validateOrder() {
    if (this.plotSeedOrder.RequestedDate) {
      return true;
    }
    else {
      this.toastrService.error('Requested By Date is not valid');
      return false;
    }

  }

  enableDisablePlaceOrder() {
    if (this.plotSeedOrderSource && this.plotSeedOrderSource.data && this.plotSeedOrderSource.data.length > 0 && (this.isOrderEditable || (this.totalOrderQuantity > 0 && ((this.errorMsgs && this.errorMsgs.length === 0) || !this.errorMsgs) && this.plotSeedOrder.ProductLine && this.plotSeedOrder.ShipToAccount && this.plotSeedOrder.SalesManagerAccount))) {
      this.isPlaceOrderDisable = false;
    }
    else {
      this.isPlaceOrderDisable = true;
    }
  }

  getSalesManager($event) {
    this.selectedSalesManager = $event;
    this.shipToData = [];
    this.plotSeedOrder.ShipToAccount = null;
    this.selectedDealer = null;
    this.deliverToData = [];
    this.plotSeedOrder.DeliverToAccount = null;
    this.deliverTo = null;
    this.plotSeedOrder.DeliverToAnotherLocation = false;
    this.originalItemList = null;
    this.clearDetailGrid();
    this.availableMaturityOptions = null;
    this.broadcastService.broadcast(this.configService.DATA_CHANGE, { salesManagerUpdate: true });
    if ($event && $event.accountNumber) {
      this.getShipAscAccounts($event.accountNumber);
    }
    else {
      this.resetEditFields();
      if (this.plotSeedOrderSource.data.length > 0) {
        this.plotSeedOrderSource = null;
        this.plotSeedOrderSourceCopy = null;
        this.bindDataSource([], false);
      }
      this.enableSearchButton = false;
      this.plotSeedOrder.ProductLine = null;
    }
  }

  getShipTo($event) {
    if ($event && $event.accountType == "F") {
      this.disableDeliverTo = true;
    }
    else {
      this.disableDeliverTo = false;
    }
    this.selectedDealer = $event;
    this.deliverToData = [];
    this.plotSeedOrder.DeliverToAccount = null;
    this.deliverTo = null;
    this.plotSeedOrder.DeliverToAnotherLocation = false;
    this.broadcastService.broadcast(this.configService.DATA_CHANGE, { shiptoupdated: true });
    if ($event && $event.accountNumber) {
      this.getDeliverToAccounts($event);
    }
    else {
      this.resetEditFields(true);
    }
    this.enableDisablePlaceOrder();
  }

  getDeliverToAccounts($event) {
    if ($event) {
      this.broadcastService.broadcast(this.configService.DATA_CHANGE, { deliverToUpdated: true });
    }
    if ($event && $event.accountNumber && $event.parentNumber) {
      this.getDeliverToAccountsListBasedOnShipto($event.accountNumber, $event.parentNumber);
    }
  }

  getProductLineChange() {
    if (this.plotSeedOrder.ProductLine && this.isUserSalesManager && this.CheckforProductLineSetup(this.plotSeedOrder.ProductLine)) {
      this.toastrService.error('Ordering Period has closed.');
      this.broadcastService.broadcast(this.configService.DATA_CHANGE, {
        updateButtonClick: true
      });
      this.navigateToPlotSeedLanding();
      return;
    }
    this.originalItemList = null;
    this.enableSearchButton = false;
    this.availableMaturityOptions = null;
    this.clearDetailGrid();
    this.checkExistingOrder();
  }

  CheckforProductLineSetup(productLineId){
    const item = this.productLineDateSetupList
      ?.find(x => x.id === productLineId);
    if (item?.value === 'N') {
      return true;
    }
    return false;
  }


  getShipAscAccounts(accountNumber) {
    this.loaderService.setLoaderStatus(true);
    this.subscription.push(this.plotSeedService.getPlotSeedShipToAscAccounts(accountNumber).subscribe(result => {
      if (result && result.length > 0) {
        this.shipToData = result;
      }
      this.loaderService.setLoaderStatus(false);
      this.checkExistingOrder();
    }, (error => {
      this.loaderService.setLoaderStatus(false);
    })));
  }

  getDeliverToAccountsListBasedOnShipto(accountNumber, parentAccountNumber) {
    this.loaderService.setLoaderStatus(true);
    this.subscription.push(this.plotSeedService.getPlotSeedDeliverTo(accountNumber, parentAccountNumber).subscribe(result => {
      if (result && result.length > 0) {
        this.deliverToData = result;
      }
      this.checkExistingOrder(true);
      this.loaderService.setLoaderStatus(false);
    }, (error => {
      this.loaderService.setLoaderStatus(false);
    })));
  }

  removeDeliverTo() {
    if (!this.plotSeedOrder.DeliverToAnotherLocation && this.plotSeedOrder.DeliverToAccount) {
      this.enableDisablePlaceOrder();
    }
    this.plotSeedOrder.DeliverToAccount = null;
    this.deliverTo = null;    
  }
  // Deliver to change event add the object to show the deliver to address
  getDeliverToAccount($event) {
    this.deliverTo = $event;
    if ($event) {
      this.broadcastService.broadcast(this.configService.DATA_CHANGE, { deliverToUpdated: true });
    }
    this.enableDisablePlaceOrder();
  }

  checkExistingOrder(isShipTo = false) {
    if (this.plotSeedOrder.SalesManagerAccount && this.plotSeedOrder.ProductLine && this.plotSeedOrder.ShipToAccount) {
      this.loaderService.setLoaderStatus(true);
      this.subscription.push(this.plotSeedService.checkExistingOrder(this.plotSeedOrder.SalesManagerAccount, this.plotSeedOrder.ShipToAccount, this.plotSeedOrder.ProductLine).subscribe((headerId: number) => {
        this.loaderService.setLoaderStatus(false);
        if (headerId && headerId > 0) {
          this.orderHeaderId = headerId;
          this.isPlaceOrderDisable = true;
          this.loadOrderDetails();
        }
        else {
          this.resetEditFields(isShipTo);
          this.displayedColumns = ['marketingBrand', 'variety', 'maturity', 'orderQty', 'uom'];
        }
      }, error => {
        this.loaderService.setLoaderStatus(false);
      }));
    }
    else {
      this.resetEditFields(isShipTo);
    }
  }

  // Place Plot Seed Order
  placePlotSeedOrder() {
    if (this.validateOrder()) {
      let plotSeedOrderData = this.getOrderList();
      this.loaderService.setLoaderStatus(true);
      this.subscription.push(this.plotSeedService.placePlotSeedOrder(plotSeedOrderData).subscribe((result: any) => {
        if (result && result.orderHeaderId) {
          if (this.isOrderEditable) {
            this.toastrService.success(`Plot Seed Order ${result.webOrderNumber} Successfully Updated`);
          }
          else {
            this.toastrService.success(`Plot Seed Order ${result.webOrderNumber} Successfully Saved`);
          }
          
          this.loaderService.setLoaderStatus(false);
          this.broadcastService.broadcast(this.configService.DATA_CHANGE, {
            updateButtonClick: true
          });

          this.plotSeedService.setConfirmationPlotSeedOrderId(+result.orderHeaderId);
          this.plotSeedService.setRedirectionFrom(this.isOrderEditable ? 'Update' :'Add');
          this.router.navigate(['/plot-seed/plot-seed-summary']);
        } else {
          let rowId: Number = 0;
          this.errorMsgs = new Array();
          this.originalItemList = result.orderDetailsData;
          this.originalItemList.forEach(product => {
            rowId = +rowId + 1;
            product.rowId = +rowId;
            product.lineErrors = { 'rowId': product.rowId, 'errors': [] };
            if (product.errors && product.errors.length > 0) {
              product.errors.forEach(itemError => {
                product.lineErrors.errors.push({ id: itemError.id, error: itemError.error });
                if (product.lineErrors.errors.length > 0) {
                  this.errorMsgs = this.errorMsgs.filter(x => x.rowId != product.rowId);
                  this.errorMsgs.push(product.lineErrors);
                  this.getCommonErrors(this.errorMsgs);
                }
              });
            }
          });
          this.bindDataSource(this.originalItemList, true);
          this.isPlaceOrderDisable = true;
        }
        this.loaderService.setLoaderStatus(false);
      }, error => {
        this.loaderService.setLoaderStatus(false);
        this.toastrService.error('Order not saved in the system.');
      }));
    }
  }

  // Search the account details on shipto / Deliverto dropdown
  accountSearchFn(term: string, item: any) {
    term = term.toLocaleLowerCase();
    return item.accountName.toLocaleLowerCase().indexOf(term) > -1
      || item.accountNumber.toString().indexOf(term) > -1
      || item.address1.toLocaleLowerCase().indexOf(term) > -1
      || item.city.toLocaleLowerCase().indexOf(term) > -1
      || item.state.toLocaleLowerCase().indexOf(term) > -1
      || item.zipCode.toLocaleLowerCase().indexOf(term) > -1;
  }

  getFilterData() {
    this.keepFilter();
    //this.applyFilterData(this.productFilters);
  }

  // Keep the selected filter in case of edit
  keepFilter() {
    if (this.filterValueList) {
      // Create filterValueList from Product Filters
      this.filterValueList = [];
      if (this.productFilters) {
        if (this.productFilters.Variety && this.productFilters.Variety != '') {
          this.filterValueList.push('Hybrid Variety : ' + this.productFilters.Variety);
        }
        if (this.productFilters.MaturityFrom && this.productFilters.MaturityFrom != '') {
          this.filterValueList.push('Maturity From : ' + this.productFilters.MaturityFrom);
        }
        if (this.productFilters.MaturityTo && this.productFilters.MaturityTo != '') {
          this.filterValueList.push('Maturity To : ' + this.productFilters.MaturityTo);
        }

        if (this.productFilters.MarketingBrandList && this.productFilters.MarketingBrandList.length > 0) {
          let strMB = '';
          this.productFilters.MarketingBrandList.forEach(x => {
            strMB = strMB + (x ? x : 'Blank') + ', ';
          });
          this.filterValueList.push('Marketing Brand : ' + strMB.substr(0, strMB.length - 2));
        }
      }
    }

  }

  // Clear the selected filters
  clearAllFilter() {
    this.filterValueList = new Array();
    this.resetProductFilter();
    this.applyFilterData(this.productFilters);
  }

  // Clear single filter
  clearFilter(filterValue) {
    const index = this.filterValueList.indexOf(filterValue);
    if (index > -1) {
      this.filterValueList.splice(index, 1);
      // remove product filter
      this.removeProductFilter(filterValue);
      this.applyFilterData(this.productFilters);
      this.onSearchClick();
      if (this.filterValueList.length < 1) {
        // remove all filter
      }
    }
  }



  // To remove clear search filter
  removeProductFilter(filterValue) {
    const removeFilter = filterValue.split(' : ');
    const index = -1;
    switch (removeFilter[0].trim()) {
      case 'Maturity From':
        this.productFilters.MaturityFrom = null;
        break;
      case 'Maturity To':
        this.productFilters.MaturityTo = null;
        break;
      case 'Hybrid Variety':
        this.productFilters.Variety = '';
        break;
      default:
        break;
    }
  }

  // Reset the filters
  resetProductFilter() {
    this.productFilters = {
      Variety: '',
      MaturityFrom: null,
      MaturityTo: null
    };
    this.bindDataSource(this.originalItemList, true);
  }



  // Filter grid data on type
  applyFilterData(filterValue: any) {
    this.plotSeedOrderSource.filter = filterValue;
  }

  quantityTextChange(productItem) {
    if (/^0/.test(productItem.orderQty) && productItem.orderQty != '0') {
      productItem.orderQty = productItem.orderQty.replace(/^0/, '');
    }
    productItem.lastUpdatedTime = new Date();
    this.validateUpdateTotalOrderQuantity(productItem);
  }

  // Plot Seed Order Unit Change and validation
  OrderUnitChange(action: string, productItem: any) {
    // Ensure orderQuantity is a number (handle null/undefined/empty string)
    const currentQty = isNaN(+productItem.orderQuantity) ? 0 : +productItem.orderQuantity;

    if (action === 'decrease') {
      productItem.orderQuantity = Math.max(0, currentQty - 1);
    }
    else if (action === 'increase') {
      productItem.orderQuantity = currentQty + 1;
    }

    // Apply max limit if availableQty exists
    if (productItem.availableQty != null) {
      productItem.orderQuantity = Math.min(productItem.orderQuantity, +this.avilableQuantity);
    }

    productItem.lastUpdatedTime = new Date();

    this.validateUpdateTotalOrderQuantity(productItem);
    //this.validateLineItem(productItem, 'orderQuantity');
  }

  updateOriginalItemListById(id: number, value: any, type: "orderQuantity" | "errors") {
    const item = this.originalItemList.find(x => x.rowId === id);
    if (!item) return;

    type === "orderQuantity"
      ? (item.orderQuantity = +value)
      : (item.lineErrors.errors = value);
  }


  validateUpdateTotalOrderQuantity(item) {
    this.totalOrderQuantity = 0;
    this.updateOriginalItemListById(item.rowId, +item.orderQuantity, "orderQuantity");
    this.originalItemList.filter(x => +x.orderQuantity > 0).forEach(x => {
      this.totalOrderQuantity += +x.orderQuantity;
    });


    if (this.totalOrderQuantity > this.avilableQuantity) {
      if (item.orderQuantity > 0) {
        item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'availableUnits');
        item.lineErrors.errors.push({
          id: 'availableUnits', error: 'Total Order Quantity cannot be more than Available Quantity'
        });
      }
      else {
        item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'availableUnits');
      }

      this.errorMsgs = this.errorMsgs.filter(x => x.rowId != item.rowId);
      this.errorMsgs.push(item.lineErrors);
    }
    else {
      const errorProducts = this.plotSeedOrderSource.data.filter(
        x => x.lineErrors && x.lineErrors.errors && x.lineErrors.errors.length > 0
      );
      errorProducts.forEach(item => {
        item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'availableUnits');
        this.errorMsgs = this.errorMsgs.filter(x => x.rowId != item.rowId);
      });
    }

    this.getCommonErrors(this.errorMsgs);
    this.enableDisablePlaceOrder();
    this.updateOriginalItemListById(item.rowId, item.lineErrors.errors, "errors");
    this.IsLinesGreaterThanZeroDisable = this.totalOrderQuantity <= 0;
    if (this.totalOrderQuantity <= 0) {
      this.filterData(false);
      this.plotSeedOrder.IsLinesGreaterThanZero = false;
    }

    this.plotSeedOrderSourceCopy = JSON.parse(JSON.stringify(this.originalItemList));
  }

  // Bind data source
  bindDataSource(orderList: any, isClone: boolean, isExistingOrder = false) {
    if (orderList && orderList != null) {
      orderList = this.plotSeedOrder.IsLinesGreaterThanZero
        ? orderList.filter(x => x.orderQuantity > 0)
        : orderList;

      this.plotSeedOrderSource = new MatTableDataSource(orderList);

      this.plotSeedOrderSource.filterPredicate = (data: any, filter: any) => {
        if (data.variety == null || data.variety == 'undefined') {
          data.variety = '';
        }
        if ((filter.Variety == null || data.variety.toLowerCase().indexOf(filter.Variety.toLowerCase()) > -1)) {
          return true;
        }
        else {
          return false;
        }
      };

      // this.applyFilterData(this.productFilters);
      // created deep copy
      if (isClone) {
        this.plotSeedOrderSourceCopy = JSON.parse(JSON.stringify(orderList));
      }
      if (!isExistingOrder) {
        this.enableDisablePlaceOrder();
      }
    }
  }

  // Validate date
  validateDate($event) {
    const currentDate = (new Date()).toLocaleDateString('en-US').replace(/\u200E/g, '');
    if ($event.value < currentDate) {
      this.plotSeedOrder.RequestedDate = currentDate;
      this.broadcastService.broadcast(this.configService.DATA_CHANGE, { requestedDateUpdated: true });
      this.validateUserinput(true);
    }
    this.enableDisablePlaceOrder();
  }


  // Validate input
  validateInput(data: any, message: string) {
    if ((typeof (data) === 'undefined' || data === null || (data == ''))) {
      if (!(this.errorsList.indexOf(message) > -1)) {
        this.errorsList.push(message);
      }
      return true;
    } else {
      return false;
    }
  }

  // Validate the validations
  validateUserinput(checkRequestedDate: boolean) {
    this.error = false;
    this.errorsList = [];
    const todayDate = new Date();
    todayDate.setHours(0, 0, 0, 0);
    const reqDate = new Date(this.plotSeedOrder.RequestedDate);
    if (checkRequestedDate) {
      if (reqDate < todayDate) {
        if (!(this.errorsList.indexOf('Requested date should be greater than or equal to today') > -1)) {
          this.errorsList.push('Requested date should be greater than or equal to today');
        }
      }
    } else {
      this.validateInput(this.plotSeedOrder.ShipToAccount, 'Please select Ship To');
      this.validateInput(this.plotSeedOrder.RequestedDate, 'Please select Requested Date');
    }

    if (this.errorsList.length !== 0) {
      this.error = true;
      $('.seedEfulfillmentOuter').scrollTop(0);
    }
  }


  // Hide/show common error
  getCommonErrors(errors: any) {
    if (errors && errors.length > 0) {
      this.errorMsgs = [];
      this.errorMsgs = errors;
      this.showErrorBlock = true;
    }
    else {
      this.showErrorBlock = false;
    }
  }

  // To revert changes
  revertToPreviousError(element: any, isSingleLine) {
    if (element && element != null && this.plotSeedOrderSourceCopy.length > 0 && this.plotSeedOrderSource.data.length > 0) {
      if (element && element != null && isSingleLine) {
        // get old data
        const oldLineValue = this.plotSeedOrderSourceCopy.filter(x => x.rowId == element.rowId)[0];

        // get current object index
        const currentLineIndex = this.plotSeedOrderSource.data.findIndex(x => x.rowId == element.rowId);
        // replace current with old object if exist

        let totalQty = 0;
        this.originalItemList.filter(x => x.rowId !== element.rowId && x.orderQuantity > 0).forEach(x => {
          totalQty += +x.orderQuantity;
        });
        const availabeQty = this.avilableQuantity - totalQty;
        let qty = availabeQty > 0 ? availabeQty : 0;

        if (oldLineValue) {
          oldLineValue.orderQuantity = +qty;
          oldLineValue.lineErrors.errors = [];
        }
        this.totalOrderQuantity = totalQty + +qty;
        const index = this.originalItemList.findIndex(x => x.rowId === element.rowId);
        if (index != -1) {
          this.originalItemList[index].lineErrors.errors = [];
          this.originalItemList[index].orderQuantity = +qty;
        }

        this.IsLinesGreaterThanZeroDisable = this.totalOrderQuantity <= 0;


        if (currentLineIndex != -1) {
          this.plotSeedOrderSource.data[currentLineIndex] = JSON.parse(JSON.stringify(oldLineValue));
        }

        this.errorMsgs = this.errorMsgs.filter(x => x.rowId != element.rowId);
        this.bindDataSource(this.plotSeedOrderSource.data, false);
        // to hide one error after revert changes
        this.showHideLineError(element.rowId);
        if (this.totalOrderQuantity <= 0) {
          this.filterData(false);
          this.plotSeedOrder.IsLinesGreaterThanZero = false;
        }
        this.index = 0;
        this.currentErrorRow = 1;
        this.plotSeedOrderSourceCopy = JSON.parse(JSON.stringify(this.originalItemList));
      }
      else {
        // To hide all errors after revert all changes

        this.originalItemList.forEach(x => {
          if (x.lineErrors.errors.length != 0) {
            const index = this.plotSeedOrderSource.data.findIndex(y => y.rowId == x.rowId);
            const oldLineValue = this.plotSeedOrderSourceCopy.filter(y => y.rowId == x.rowId)[0];
            let totalQty = 0;
            this.originalItemList.filter(y => y.rowId !== x.rowId && y.orderQuantity > 0).forEach(z => {
              totalQty += +z.orderQuantity;
            });
            const availabeQty = this.avilableQuantity - totalQty;
            let qty = availabeQty > 0 ? availabeQty : 0;
            this.totalOrderQuantity = totalQty + +qty;

            if (oldLineValue) {
              oldLineValue.orderQuantity = +qty;
              oldLineValue.lineErrors.errors = [];
            }
            x.orderQuantity = +qty;
            if (index != -1) {
              this.plotSeedOrderSource.data[index].orderQuantity = +qty;
              this.plotSeedOrderSource.data[index].lineErrors.errors = [];
            }
            x.lineErrors.errors = [];
            this.showHideLineError(x.rowId);
          }
        });

        this.IsLinesGreaterThanZeroDisable = this.totalOrderQuantity <= 0;
        // To hide common error msg
        this.errorMsgs = new Array();
        this.bindDataSource(this.plotSeedOrderSource.data, false);
        if (this.totalOrderQuantity <= 0) {
          this.filterData(false);
          this.plotSeedOrder.IsLinesGreaterThanZero = false;
        }
        this.plotSeedOrderSourceCopy = JSON.parse(JSON.stringify(this.originalItemList));
      }
    }
  }


  filterData(getZeroQtyRecordsChecked: boolean) {
    this.plotSeedOrder.IsLinesGreaterThanZero = getZeroQtyRecordsChecked;
    this.applyAllFilters(true);
  }

  // Hide and show error line error
  showHideLineError(errorId: number) {
    if (errorId > 0) {
      const errorDiv = $('#error_' + errorId.toString());
      if (errorDiv) {
        errorDiv.hide();
      }
    }
    else {
      if (this.errorMsgs && this.errorMsgs.length > 0) {
        this.errorMsgs.forEach(x => {
          const errorDiv = $('#error_' + x.rowId.toString());
          if (errorDiv) {
            errorDiv.show();
          }
        });
      }
    }
  }

  // Show the next error
  nextError() {
    this.index = this.errorMsgs.findIndex(x => x.rowId == this.nextErrorId) + 1;
    if (this.errorMsgs.indexOf(this.errorMsgs[this.index]) != -1) {
      this.nextErrorId = this.errorMsgs[this.index].rowId;
      this.currentErrorRow = this.index + 1;
      $('#orderView').scrollTop = 0;
      const nextOffset = $('#error_' + this.nextErrorId.toString()).offset().top;
      $('#orderView').animate({ scrollTop: nextOffset }, 1000);
    }
    else {
      this.index = 0;
      this.nextErrorId = this.errorMsgs[this.index].rowId;
      this.currentErrorRow = 1;
      $('#orderView').scrollTop = 0;
      $('#orderView').animate({ scrollTop: 0 }, 1000);
    }
  }

  // Revert all changes
  revertAllChanges() {
    this.index = 0;
    this.currentErrorRow = 1;
    this.revertToPreviousError([], false);
    this.hideCommonError();
  }

  // Hide common error
  hideCommonError() {
    this.showErrorBlock = false;
  }
  // Go to landing seed fulfillment page
  navigateToPlotSeedLanding() {
    this.router.navigate(['/plot-seed-landing']);
  }

  ngOnDestroy() {
    this.plotSeedService.setPlotSeedOrderId(0);
    this.subscription.forEach(subscription => subscription.unsubscribe());
  }
}
// Class model for Release
export class PlotSeedOrder {
  SalesManagerAccount: number;
  OrderNumber: string;
  PlotSeedOrderId: number;
  ShipToAccount: number;
  DeliverToAccount: number;
  DeliverToAnotherLocation: boolean;
  RequestedDate: any;
  IsCustomerPickup: boolean;
  IsLinesGreaterThanZero: boolean;
  DeliveryInstructionsCodes: string;
  CustomerPO: string;
  ProductLine: string;
  CompanyCode: string;
  PlotSeedOrderItemsList: Array<PlotSeedOrderItems> = [];
}


export class PlotSeedOrderItems {
  PlotSeedOrderId: number;
  PlotSeedOrderDetailId: number;
  MarketingBrand: string;
  Variety: string;
  OrderQty: number;
  UOM: string;
}

